import { Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

function ContratosCell({ row }) {
  const navigate = useNavigate();
  const employeeId = row.employee?.id;
  if (!employeeId) return null;
  return (
    <Button
      size="xs"
      variant="outline"
      colorScheme="teal"
      onClick={() => navigate(`/admin/employee-contracts?employeeId=${employeeId}`)}
    >
      Contratos
    </Button>
  );
}

export const columnsDataTeaching = [
  {
    Header: "Documento",
    accessor: "document",
  },
  {
    Header: "Apellidos",
    accessor: "lastNames",
    computedValue: (row) => `${row.lastName} ${row.maternalLastName}`,
  },
  {
    Header: "Nombres",
    accessor: "names",
    computedValue: (row) => `${row.name} ${row.secondName}`,
  },
  {
    Header: "Mail",
    accessor: "email",
  },
  {
    Header: "Celular",
    accessor: "cellPhone",
  },
  {
    Header: "Contratos",
    accessor: "contracts",
    Cell: ({ row }) => <ContratosCell row={row.original} />,
  },
];
